module.exports = __webpack_public_path__ + "img/linkedin.38c1514e.png";